const ActionsPerformanceFilterPanel = ({ title, icon, children }) => {
  return (
    <div className="flex flex-col">
      <div className="flex flex-row items-center gap-x-2 mb-2">
        {icon}
        <div className="font-semibold">{title}</div>
      </div>
      {children}
    </div>
  );
};

export default ActionsPerformanceFilterPanel;
